(function (ws) {
    'use strict';
    ws.views.loginCountryBox = ws.views.googleAnalytics.extend({

        events: {
            'change .country-select': 'updateLanguages',
            'click .select-language-dropdown': 'gtmOnCountryClick',
            'click #select-country-submit': 'submitForm'
        },

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'user',
        GTM_EVENT_ACTION: 'login_select_country_language',
        GTM_EVENT_ACTION_DROPDOWN: 'login_language_dropdown_view',

        /**
         * Initialize
         */
        initialize: function () {
            this.selectCountryBox = this.$('#login-country-box');
            this.countrySelectDropdown = this.$('.country-select');
            this.languages = null;
            this.selectLanguageDropdownContainer = this.$('.language-dropdown-container');
            this.selectLanguageDropdownTemplate = _.template($('#select-language-dropdown').html());
            this.countriesData = this.countrySelectDropdown.data('countries-data');
            this.submitButton = this.$('#select-country-submit');
            this.defaultCountry = this.$('#defaultCountry');
            this.selectedLanguage = this.$('#selectedLanguage').text();
            this.selectCountryForm = this.$('#selectCountryForm');

            this.checkSubmitBtnStatus();

            this.isVisible = this.selectCountryBox.is(':visible');

            $('#country-flag-a').on('click', this.showCountryBox.bind(this));
            $(document).on('click', this.onDocumentClick.bind(this));
            this.eventAgg.trigger('showLoginCountryBox', this.isVisible);

            this.render();

            if ($('#ssoLogoutFlag').val() === 'true') {
                window.location.href = $('#ssoLogoutUrl').val();
            }
        },

        /**
         * Sends the Google Analytics data when the user submits the form.
         */
        gtmSubmit () {
            let country = this.countrySelectDropdown.find(':selected').text();
            let language = this.$('.select-language-dropdown').find(':selected').text();
            console.log(this.countrySelectDropdown.find(':selected').data('itemcode'));
            let salesOrg = _.findWhere(this.countriesData, { code: this.countrySelectDropdown.find(':selected').data('itemcode') });

            this.eventDataLayer = {
                event: this.GTM_EVENT_NAME,
                eventCategory: this.GTM_EVENT_CATEGORY,
                eventAction: this.GTM_EVENT_ACTION,
                eventLabel: [country, language, salesOrg.countrySalesOrg].join('_'),
                country: country,
                language: language,

                // jscs:disable
                sales_org: salesOrg.countrySalesOrg
                // jscs:enable
            };

            this.logGTMEvent();
        },

        /**
         * Submit form and disable App
         * @param {Event} e
         */
        submitForm: function (e) {
            e.preventDefault();
            this.gtmSubmit();
            this.selectCountryForm.submit();
            globals.disableApp();
        },

        /**
         * Render
         */
        render: function () {
            this.countrySelectDropdown.trigger('change');
        },

        /**
         * Check dropdowns status and disable submit button if necessary
         */
        checkSubmitBtnStatus: function () {
            if (!this.$('.select-language-dropdown').val() || !this.$('.select-language-dropdown').val()) {
                this.submitButton.prop('disabled', 'disabled');
                this.submitButton.toggleClass('disabled', true);
            } else {
                this.submitButton.prop('disabled', false);
                this.submitButton.toggleClass('disabled', false);
            }
        },

        /**
         * Render Languages Dropdown
         */
        renderLanguageDropdown: function() {
            return this.selectLanguageDropdownTemplate({data: {languages: this.languages, selectedLanguage: this.selectedLanguage}});
        },

        /**
         * Sends the Google Analytics data when a user shows the country/language box.
         */
        gtmOnCountryClick() {
            let language = this.$('.select-language-dropdown').find(':selected').text();

            this.eventDataLayer = {
                event: this.GTM_EVENT_NAME,
                eventCategory: this.GTM_EVENT_CATEGORY,
                eventAction: this.GTM_EVENT_ACTION_DROPDOWN,
                eventLabel: language
            };

            this.logGTMEvent();
        },

        /**
         * Toggle class hide for Login country box
         */
        showCountryBox: function (e) {
            e.preventDefault();
            e.stopPropagation();
            this.selectCountryBox.fadeToggle('fast');
            this.isVisible = !this.isVisible;
            this.eventAgg.trigger('showLoginCountryBox', this.isVisible);
            if ($(e.currentTarget)[0].activeElement) {
                let link = $(e.currentTarget)[0].activeElement.href;
                if (link) {
                    window.location.href = link;
                }
            }
        },

        /**
         * Handle click outside of country box
         * and clicks in nav menu
         * when country box is visible.
         */
        onDocumentClick: function (e) {
            const $target = $(e.target);
            const hasClickedOutsideBox = $target.closest('#login-country-box').length === 0;
            const hasClickedOnNavigationCTA = $target.closest('#country-flag-a').length !== 0;

            if ((hasClickedOutsideBox || hasClickedOnNavigationCTA) && this.isVisible) {
                this.showCountryBox(e);
            }
        },

        /**
         * Update languages with new data
         */
        updateLanguages: function (e) {
            const selected = $(e.currentTarget);
            const selectedOption = selected.find('option:selected');
            this.$('#countryCode').val($(selectedOption).data('itemcode'));
            const key = _.findIndex(this.countriesData, {
                code: $(selectedOption).data('itemcode')
            });

            this.languages = this.countriesData[key] ? this.countriesData[key].languages : null;
            this.selectLanguageDropdownContainer.html(this.renderLanguageDropdown());
            this.checkSubmitBtnStatus();
        }
    });
})(westcon);
